import { render, staticRenderFns } from "./users-settings.vue?vue&type=template&id=4e27c8ea"
import script from "./users-settings.vue?vue&type=script&lang=js"
export * from "./users-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports